import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import styled from "styled-components";
import { FaCheckCircle, FaSpinner, FaExclamationCircle } from "react-icons/fa";
import SubmitFileDetails from "./SubmitFileDetails";
import FileStatusesDetailExcelDownload from "./FileStatusesDetailExcelDownload";
import RefreshTitle from "./RefreshTitle";

const StyledIcon = styled.div`
  color: ${(props) => props.color};
`;

function FileUploadStatusDetail({ fileHeadId, fileStatusData }) {
  const [loading, setloading] = useState(false);
  const [fileStausDetailsData, setfileStausDetailsData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(null);

  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const getFileStatus = async () => {
    setloading(true);
    const res = await handleGetRequest(
      "zbizgateway/fileStatusCheck/fileUploadStatusDetail/" + fileHeadId
    );
    setfileStausDetailsData(res?.data);
    setloading(false);
  };

  const STATUS_CONFIG = {
    I: {
      color: "orange",
      icon: <FaSpinner />,
      text: "In Progress",
    },
    S: {
      color: "green",
      icon: <FaCheckCircle />,
      text: "Success",
    },
    E: {
      color: "red",
      icon: <FaExclamationCircle />,
      text: "Error",
    },
    P: {
      color: "green",
      icon: <FaCheckCircle />,
      text: "Processed",
    },
  };

  const statusBodyTemplate = (rowData) => {
    const config = STATUS_CONFIG[rowData?.statusCode];

    if (!config) return null;

    return (
      <StyledIcon color={config.color}>
        <span style={{ verticalAlign: "middle" }}>{config.icon}</span>{" "}
        <span>{config.text}</span>
      </StyledIcon>
    );
  };

  // const TransactionsTableHeader = (
  //     <div style={{ display: "flex", justifyContent: "space-between" }}>
  //         <p>Transactions</p>
  //         <div>
  //             <FileStatusesDetailExcelDownload data={fileStausDetailsData} fileStatusData={fileStatusData} />
  //         </div>
  //     </div>
  // )

  useEffect(() => {
    if (fileHeadId !== null) {
      getFileStatus();
    }
  }, [fileHeadId]);

  if (fileHeadId === null) {
    return null;
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            {/* <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} /> */}
            <h3 className="mod_heading">Transactions</h3>
          </div>
          <FileStatusesDetailExcelDownload
            data={fileStausDetailsData}
            fileStatusData={fileStatusData}
          />
        </div>
      </div>
      <div className="card">
        <div className="p-d-flex p-jc-start">
          {(fileStatusData && fileStatusData?.mcStatus === "A") ||
          fileStatusData?.mcStatus === "R" ||
          fileStatusData?.mcStatus === "I" ? (
            ""
          ) : (
            <>
              <SubmitFileDetails
                fileHeadId={fileHeadId}
                fileStausDetailsData={fileStausDetailsData}
              />
              <RefreshTitle fileStausData={selectedFiles} />
            </>
          )}
        </div>

        <DataTable
          // header={TransactionsTableHeader}
          value={fileStausDetailsData}
          selectionMode="multiple"
          metaKeySelection={false}
          selection={selectedFiles}
          onSelectionChange={(e) => {
            setSelectedFiles(e.value);
          }}
          dataKey="fileDetailId"
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          emptyMessage="No data found."
          autoLayout
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
          {/* <Column filter field="chequeNo" header="Cheque No" /> */}
          {/* <Column filter field="companyName" header="Company Name" /> */}
          {/* <Column filter field="t24AccountNo" header="T24 Account No" /> */}
          {/* <Column filter field="t24AccountTitle" header="T24 Account Title" /> */}
          <Column filter field="employeeName" header="Name" />
          <Column filter field="employeeNo" header="Employee No" />
          <Column filter field="titleFetchStatus" header="T24 Status" />
          {/* <Column filter field="nameStatus" header="Name Status" /> */}
          <Column filter field="employeeCnic" header="Cnic" />
          {/* <Column filter field="cnicStatus" header="CNIC Status" /> */}
          <Column filter field="employeeAccountNo" header="Account No" />
          <Column filter field="accountNoStatus" header="Account No Status" />
          <Column
            filter
            field={(item) =>
              item?.amount &&
              parseInt(item?.amount).toLocaleString("en-PK").split(".")[0]
            }
            header="Amount"
          />
          {/* <Column filter field="segment" header="Segment" /> */}
          <Column filter field="transactionCode" header="Trx ID" />
          {/* <Column filter field="createdate" header="Transaction Create Date" /> */}
          <Column
            filter
            field="statusCode"
            filterField={(rowData) =>
              rowData?.statusCode === "I"
                ? "In Progress"
                : rowData?.statusCode === "S"
                ? "Success"
                : rowData?.statusCode === "E"
                ? "Error"
                : rowData?.statusCode === "P"
                ? "Processed"
                : null
            }
            header="Status"
            body={statusBodyTemplate}
            filterMatchMode="contains"
          />
          <Column filter field="statusDescr" header="Status Description" />
        </DataTable>
      </div>
    </div>
  );
}

export default FileUploadStatusDetail;
